import { all, call } from 'redux-saga/effects';
import PostResetPasswordSaga from './authSaga/PostResetPasswordSaga';
import autoGeneratePasswordSaga from './authSaga/autoGeneratePasswordSaga';
import setPasswordSaga from './authSaga/setPasswordSaga';
import therapistLoginSaga from './authSaga/therapistLoginSaga';
import therapistLogoutSaga from './authSaga/therapistLogoutSaga';
import createEpisodeOfCareSaga from './episodeOfCare/createEpisodeOfCareSaga';
import closeEpisodeOfCareSaga from './episodeOfCare/closeEpisodeOfCareSaga';
import editEpisodeOfCareSaga from './episodeOfCare/editEpisodeOfCareSaga';
import getEpisodeOfCareSaga from './episodeOfCare/getEpisodeOfCareSaga';
import getSingleEpisodeOfCareSaga from './episodeOfCare/getSingleEpisodeOfCareSaga';
import getFacilityDropDownSaga from './facilitySaga/assignFacilitySaga';
import createFacilitiesStaySaga from './facilitySaga/createFacilityStaySaga';
import getAllFacilitiesStaySaga from './facilitySaga/facilityStaySaga';
import updateFacilityDropDownSaga from './facilitySaga/switchFacilitySaga';
import updateFacilitiesStaySaga from './facilitySaga/updateFacilityStaySaga';
import createPtoRequestSaga from './my-availability/createPtoRequest';
import editMyAvailabilitySaga from './my-availability/edit-myAvailabilitySaga';
import getAllPtoRequestSaga from './my-availability/getAllPtoRequestSaga';
import getMyAvailabilitySaga from './my-availability/getMyAvailabilitySaga';
import removePtoRequestSaga from './my-availability/removePtoRequest';
import createPatientSaga from './patient/createPatientSaga';
import deactivatePatientsSaga from './patient/deactivatePatientSaga';
import editPatientSaga from './patient/editPatientSaga';
import getAllPhysicianSaga from './patient/getAllPhysicianSaga';
import getSinglePatientSaga from './patient/getSinglePatientSaga';
import getPatientRecordSaga from './patientSaga/getPatientRecord';
import getAllTherapistDisciplineSaga from './patientSaga/getAllDisciplineTherapistSaga';
import getSingleTherapistDisciplineSaga from './patientSaga/getSingleDisciplineTherapistSaga';
import updateTreatmentTherapistSaga from './patientSaga/putTreatmentTherapistSaga';
import createScreeningSaga from './screeningDetails/createScreeningSaga';
import getDisciplineTypeSaga from './screeningDetails/getDisciplineTypeSaga';
import getScreeningSaga from './screeningDetails/getScreeningSage';
import getScreeningTypeSaga from './screeningDetails/getScreeningTypeSaga';
import getSingleScreeningSaga from './screeningDetails/getSingleScreeningSaga';
import therapistAddTaskSaga from './therapistSaga/therapistAddtaskSaga';
import getAllTherapistListSaga from './therapistSaga/therapistListSaga';
import getTherapistProfileSaga from './therapistSaga/therapistProfileSaga';
import getAllTherapistTaskSaga from './therapistSaga/therapistSchedulingSaga';
import getSkillListSchedulingSaga from './therapistSaga/getSkillsListScheduling';
import getAllTaskTypeSaga from './therapistSaga/therapistTaskSaga';
import getAppointmentSlotsSaga from './therapist-scheduling-saga/getAppointmentSlotsSaga';
import scheduleAppointmentSaga from './therapist-scheduling-saga/scheduleAppointmentSaga';
import scheduleRecurringAppointmentSaga from './therapist-scheduling-saga/scheduleRecurringAppointmentSaga';
import updateRecurringSeriesSaga from './therapist-scheduling-saga/updateRecurringSeriesSaga';
import cancelRecurringSeriesSaga from './therapist-scheduling-saga/cancelRecurringSeriesSaga';
import getPatientTimeSlotsSaga from './therapist-scheduling-saga/getPatientTimeSlotsSaga';
import getRecurringAppointmentCountSaga from './therapist-scheduling-saga/getRecurringAppointmentCountSaga';
import getAllSubmittedDocumentForResolver from './documentation/getAllSubmittedDocumentsForResolverSaga';
import {
  createAssessment,
  getAssessment,
  getMDSAssessment,
  getPlanOfCare,
  checkTherapyPlanningPlanMinutesSaga,
  getTherapyPlanning,
  updateAssessment,
  updateTherapyPlanning,
  getDataOfServiceSaga,
  getTherapyPlanningPatientSaga,
  updateTherapyPlanningDischargeDateSaga,
  getIsTherapyPlanningPatient,
} from './therapyPlanning';
import {
  getDailySessionPatientListSaga,
  getPatientInfoSaga,
  updateDailySessionNotesSaga,
  getOtherPatientInfoSaga,
  getDailySessionNotesSaga,
  updateSoapNoteSaga,
} from './dailySessionNotes';
import therapistSchedulingTaskEditSaga from './therapistSaga/therapistSchedulingTaskEditSaga';
import getAllTherapistDiciplineListSaga from './therapistSaga/therapistDisciplineSaga';
import therapistAssignTaskSaga from './therapistSaga/therapistAssignTask';
import therapistMigrateTaskSagaSaga from './therapistSaga/therapistMigratetaskSaga';
import therapistMigratePatientSaga from './therapistSaga/therapistMigratePatientSaga';
import getPayerPlanTypeSaga from './patient/getPayerPlanTypeSaga';
import therapistAssignmentUndoSaga from './therapistSaga/therapistAssignmentUndoSaga';
import getAllFacilitiesSaga from './facilitySaga/getAllFacilitiesSaga';
import getAllTemplatesSaga from './documentation/getAllTemplatesSaga';
import rearrangeTherapistTaskSaga from './therapistSaga/rearrangeTherapistTaskSaga';
import assignSignerSaga from './documentation/assignSignerSaga';
import getAllSubmittedDocumetSaga from './documentation/getAllSubmittedDocumentsSaga';
import getSubmissionDocumentSaga from './documentation/getSubmissionDocumentSaga';
import therapistDialogAssignTaskSaga from './therapistSaga/therapistDialogAssignTaskSaga';
import getAllTherapistsByDiscipline from './therapist/getAllTherapistSaga';
import getAllMiscellaneousDocumentsSaga from './documentation/getAllMiscellaneousDocumentsSaga';
import saveMiscellaneousDocumentSaga from './documentation/saveMiscellaneousDocumentSaga';
import dashboardPatientListSaga from './therapist-dashboard-saga/dashboard-patient-list-saga';
import todayPatientListSaga from './therapist-dashboard-saga/today-patient-list-saga';
import dashboardDocumentListSaga from './therapist-dashboard-saga/dashboard-document-list-saga';
import dashboardTaskOverviewSaga from './therapist-dashboard-saga/dashboard-task-overview-saga';
import dashboardDocumentationOverviewSaga from './therapist-dashboard-saga/dashboard-documentation-overview-saga';
import dashboardTherapySessionOverviewSaga from './therapist-dashboard-saga/dashboard-therapy-overview-saga';
import dashboardTimeCheckInSaga from './therapist-dashboard-saga/dashboard-check-in';
import dashboardTimeCheckOutSaga from './therapist-dashboard-saga/dashboard-checkout';
import getAllSupervisiorsSaga from './documentation/getAllSupervisiorsSaga';
import dashboardPatientInfoSaga from './therapist-dashboard-saga/dasboard-patient-info-saga';
import getEpisodeOfCareRequiredDocumentSaga from './episodeOfCare/getRequiredDocumentSaga';
import getNoteTemplateSaga from './dailySessionNotes/getNoteTemplateSaga';
import submitEsignSaga from './dailySessionNotes/submitEsignSaga';
import getFormIdForScreeningSaga from './screeningDetails/getFormIdForScreeningSaga';
import saveScreeningSubmissionSaga from './screeningDetails/save-screening-submissionSaga';
import getPatientInOrActiveCountsSaga from './patientSaga/getPatientInActiveCount';
import {
  getDepartmentDashboardCountSaga,
  getDepartmentPTOSaga,
  getDepartmentTherapyMinsSaga,
  updateDepartmentPTORequestSaga,
} from './departmentDashboard';
import sendMailToPhysicianSaga from './documentation/sendMailToPhysicianSaga';
import getMonthEndAlertCountSaga from './monthEndAlert/getMonthEndAlertCountSaga';
import getMonthEndAlertThemeCountSaga from './monthEndAlert/getThemeCountSaga';
import getOwnerAlertCountSaga from './monthEndAlert/getOwnerAlertCountSaga';
import getListofMonthEndAlertSaga from './monthEndAlert/getListofMonthEndAlertSaga';
import getAllCodesSaga from './documentation/getCodesSaga';
import autoMatchingTherapistSaga from './therapist/autoMatchingTherapistSaga';
import disableAutoMatchSaga from './therapist/disableAutoMatchSaga';
import defaultTherapistAssignSaga from './therapist/defaultTherapistAssignSaga';
import dashboardPtoUpdatedSaga from './therapist-dashboard-saga/dashboard-pto-updated-saga';
import getCPTCodeByDisciplineSaga from './therapyPlanning/getCPTCodeByDisciplineSaga';
import editAuthorizationSaga from './therapyPlanning/editAuthorizationSaga';
import getDownloadCsvTemplateSaga from './patientSaga/getDownloadCsvTemplateSaga';
import validateCSVTemplateSaga from './patientSaga/validateCSVTemplateSaga';
import uploadCsvTemplateSaga from './patientSaga/uploadCsvTemplateSaga';
import getRecentUploadedHistorySaga from './patientSaga/getRecentUploadedHistorySaga';
import getPatientExportCsvSaga from './patientSaga/getPatientExportCsvSaga';
import getTherapistAvailabilitySaga from './my-availability/getTherapistAvailabilitySaga';
import certifyMonthEndAlertSaga from './monthEndAlert/certifyMonthEndAlertSaga';
import getCertificationStatusSaga from './monthEndAlert/getCertificationStatusSaga';
import dashboardInterventionGroupSaga from './therapist-dashboard-saga/dashboard-intervention-group-saga';
import dashboardGameByInterventionGroupSaga from './therapist-dashboard-saga/dashboard-games-intervention';
import getSignatureAccessSaga from './documentation/getSignatureAccessSaga';
import getTargetSignatureAccessSaga from './documentation/getTargetSignatureAccessSaga';
import getAllPatientSaga from './patientSaga/getAllPatientSaga';
import getAuthorizationDetailsSaga from './therapyPlanning/getAuthDetails';
import getAllICDCodesSaga from './documentation/getAllICDSaga';
import pullUuidSaga from './documentation/pulluuidSaga';
import PreGetFacilityDropDownSaga from './facilitySaga/preAssignFacilitySaga';
import preGetTherapistProfileSaga from './therapistSaga/preTherapistProfileSaga';
import getPayComeDetailsSaga from './therapistSaga/gePaycomeDetailsSaga';
import clockInOutButtonVisibilitySaga from './therapistSaga/clockInOutButtonVisibilitySaga';
import reAssignTherapistSaga from './documentation/reAssignTherapistSaga';
import getAlTherapistListSaga from './documentation/getAllTherapistListSaga';
import getCaseMixGroupSaga from './therapyPlanning/getCaseMixGroupSaga';
import getCmgResolutionSaga from './therapyPlanning/getCmgResolutionSaga';
import getCmgStatusSaga from './therapyPlanning/getCmgStatusSaga';
import getPdpmFeatureToggleSaga from './therapyPlanning/getPdpmFeatureToggleSaga';
import getLaborHoursSaga from './laborHoursSaga/getLaborHoursSaga';
import getLaborCodes from './laborHoursSaga/getLaborCodesSaga';
import addLaborHoursSaga from './laborHoursSaga/addlaborHoursSaga';
import editLaborHoursSaga from './laborHoursSaga/editLaborHoursSaga';
import getLocationTypeLaborHrSaga from './laborHoursSaga/getLocationTypeLaborHrSaga';
import checkSignatureDailyNotesSaga from './dailySessionNotes/checkSignatureDailyNotes';
import deletePatientTaskSaga from './therapistSaga/deletePatientTaskSaga';
import deleteLaborHoursSaga from './laborHoursSaga/deleteLaborHoursSaga';
import getNpcEntriesSaga from './npcLogSaga/getNpcEntriesSaga';
import getNpcActivityTypesSaga from './npcLogSaga/getNpcActivityTypesSaga';
import addNpcEntrySaga from './npcLogSaga/addNpcEntrySaga';
import editNpcEntrySaga from './npcLogSaga/editNpcEntrySaga';
import deleteNpcEntrySaga from './npcLogSaga/deleteNpcEntrySaga';
import getNpcTeamEntriesSaga from './npcLogSaga/getNpcTeamEntriesSaga';
import getNpcTeamEntriesEditableSaga from './npcLogSaga/getNpcTeamEntriesEditableSaga';
import reviewNpcEntrySaga from './npcLogSaga/reviewNpcEntrySaga';
import getLaborReportSaga from './laborHoursSaga/getLaborReportSaga';
import getBuildingsOverviewSaga from './laborHoursSaga/getBuildingsOverviewSaga';
import getLaborEntryHistorySaga from './laborHoursSaga/getLaborEntryHistorySaga';
import updateLaborEntryStatusSaga from './laborHoursSaga/updateLaborEntryStatusSaga';
import getLaborValidationToggleSaga from './laborHoursSaga/getLaborValidationToggleSaga';
import getPayPeriodCyclesSaga from './laborHoursSaga/getPayPeriodCyclesSaga';
import approvePayPeriodSaga from './laborHoursSaga/approvePayPeriodSaga';
import getPayPeriodByDateSaga from './laborHoursSaga/getPayPeriodByDateSaga';
import getAllDisciplineTherapistsSaga from './therapist/getAllDisciplineTherapist';
import monthlyCloseoutAlertSaga from './monthlyCloseOutAlret/monthlyCloseoutAlertSaga';
import getUnlockTherapistSaga from './getUnlockTherapistSaga/getUnlockTherapistSaga';
import getLockDailySessionNoteSaga from './getUnlockTherapistSaga/getLockDailySessionNoteSaga';
import updateUnlockTherapistSaga from './getUnlockTherapistSaga/updateUnlockTherapistSaga';
import uploadSignatureFileSaga from './monthlyCloseOutAlret/uploadSignatureFileSaga';
import getMultipleMdsAssessmentSaga from './therapyPlanning/getMultipleMDSAssessmentSaga';
import deleteRequiredDocSaga from './documentation/deleteRequiredDocSaga';
import getPrepareProgressNoteSaga from './documentation/getPrepareProgressNoteSaga';
import getAutoClockOutSaga from './therapist-dashboard-saga/getauto-clock-out-call-saga';
import getPaginatedPatientSaga from './patientSaga/getPaginatedPatientsSaga';
import getAllCompetedDocSaga from './documentation/getAllCompetedDoc';
import dashboardDocumentListCsvSaga from './therapist-dashboard-saga/dashboardDocumentCSVListSaga';
import getCPTCodesDescriptionSaga from './copyTextBank/getCPTCodeDescriptionSaga';
import validateMdsAssessmentSaga from './therapyPlanning/validateMdsAssesmentCsvSaga';
import verifyMdsPpsSaga from './therapyPlanning/verifyMdsPpsSaga';
import uploadMdsCsvTemplateSaga from './therapyPlanning/uploadMdsCsvTemplateSaga';
import getPatientListRecordSaga from './patientSaga/getAllPatientListSaga';
import getContractCountSaga from './contract/getContractCountSaga';
import getPhysicianDocumentsSaga from './physiciansaga/getAllPhysicianDocumentsSaga';
import updateDocumentStatusesSaga from './physiciansaga/updateDocumentStatusesSaga';
import getFacilitySaga from './physiciansaga/getAllFacilitiesSaga';
import getAllPatientByEnterpriseSaga from './physiciansaga/getAllPatientByEnterprise';
import checkAssignTaskPTOSaga from './departmentDashboard/checkAssignTaskPTOSaga';
import getPhysicianCompletedDocumentsSaga from './physiciansaga/completedPhysicianDocumentSaga';
import getTherapyPlanningPatientSaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningPatient_2_0';
import getTherapyPlanningDataSaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningDataSaga_2_0';
import getTherapyPlanningSummarySaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningSummarySaga_2_0';
import editSingleCellTherapyPlanningSaga from './therapyPlanning/therapyPlanning2.0/editSingleCellTherapyPlanningSaga';
import updateAppointmentEndTimeSaga from './therapyPlanning/therapyPlanning2.0/updateAppointmentEndTimeSaga';
import updateUncoveredDayTherapyPlanningSaga from './therapyPlanning/therapyPlanning2.0/updateUncoveredDayTP_2.0';
import getTherapyPlanningDischargeDateSaga_2_0 from './therapyPlanning/therapyPlanning2.0/getTherapyPlanningDischargeDate_2.0';
import copyPasteTherapyPlanningSaga_2_0 from './therapyPlanning/therapyPlanning2.0/copyPasteTherapyPlanningSaga_2_0';
import applyTheTherapyTemplatesSaga from './therapyPlanning/therapyPlanning2.0/applyTheTherapyTemplatesSaga';
import getAllTherapyPlanningTemplatesSaga from './therapyPlanning/therapyPlanning2.0/getAllTherapyPlanningTemplates';
import applySelectedTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/applySelectedTherapyTemplateSaga';
import createNewTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/createNewTherapyTemplateSaga';
import deleteTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/deleteTherapyTemplateSaga';
import editTherapyTemplateSaga from './therapyPlanning/therapyPlanning2.0/editTherapyTemplateSaga';
import getSchedulingTaskNoteSaga from './therapist-scheduling-saga/get-scheduling-task-note-saga';
import createSchedularTaskNoteSaga from './therapist-scheduling-saga/create-note-task-scheduling-saga';
import deleteTaskNoteSchedularSaga from './therapist-scheduling-saga/delete-task-note-schedular-saga';
import therapistPatientUnAssign from './therapistSaga/therapistPatientUnAssignSaga';
import deleteMdsAssessmentByDateSaga from './therapyPlanning/therapyPlanning2.0/deleteMdsAssesmentByDateSaga';
import deleteSingleMdsAssessmentSaga from './therapyPlanning/therapyPlanning2.0/deleteSingleMdsAssessmentSaga';
import maintainTherapistFilterSaga from './therapistSaga/maintainTherapistFilterSaga';
import getAllMaintainedTherapistSaga from './therapistSaga/getAllMaintainedTherapistsSaga';
import getSchedularAnnouncementsSaga from './therapist-scheduling-saga/get-schedular-announcements-saga';
import createAnnouncementSaga from './therapist-scheduling-saga/create-schedular-announce-saga';
import updateAnnouncementSaga from './therapist-scheduling-saga/update-schedular-announce-saga';
import deleteAnnouncementSaga from './therapist-scheduling-saga/delete-schedular-announce-saga';
import getMdsAssessmentRangeSaga from './therapyPlanning/therapyPlanning2.0/getMdsAssessmentRange';
import getPayerDayCountSaga from './therapyPlanning/therapyPlanning2.0/getPayerDayCount';
import getFiveDayArdWindowSaga from './therapyPlanning/getFiveDayArdWindow';
import getSingleMdsAssessmentSaga from './therapyPlanning/therapyPlanning2.0/getSingleMdsAssessmentSaga';
import getTherapyPlanning7dayLookBackSaga from './therapyPlanning/therapyPlanning2.0/getTherapyPlanning7dayLookBackSaga';
import therapistDailyUpdatesSaga from './therapist-dashboard-saga/dashboard-therapist-daily-update-saga';
import dashboardSupervisorEditSaga from './therapist-dashboard-saga/dashboard-supervisor-edit-saga';
import isDischargeDocumentAllowSaga from './documentation/isDischargeDocumentAllowSaga';
import recheckDischargeOverrideStatusSaga from './documentation/recheckDischargeOverrideStatusSaga';
import approveRecheckDischargeSaga from './documentation/approveRecheckDischargeSaga';
import newDocumentSignSaga from './documentation/newDocumentSignSaga';
import undoDocumentSignSaga from './documentation/undoDocumentSignSaga';
import holdDailyNoteFromBillingSaga from './documentation/holdDailyNoteFromBillingSaga';
import checkPendingDocsAlertSaga from './documentation/checkPendingDocsAlert';
import setCommonDurationSaga from './therapist-scheduling-saga/set-common-duration-saga';
import updateTimeBasisSaga from './therapist-scheduling-saga/update-time-basis-saga';
import dueDocSettingsSaga from './documentation/dueDocSettingsSaga';
import otherDashboardDocumentListSaga from './therapist-dashboard-saga/therapist-bulk-signature/get-all-other-documents-dashboard';
import myDashboardDocumentListSaga from './therapist-dashboard-saga/therapist-bulk-signature/get-all-my-documents-dashboard';
import coSignatureReviewSaga from './therapist-dashboard-saga/therapist-bulk-signature/co-signatureReviewSaga';
import therapistBulkSignatureSaga from './therapist-dashboard-saga/therapist-bulk-signature/therapist-sulk-siganture-saga';
import signingPinSaga from './signing-pin-saga/signing-pin-saga';
import getPatientInfoV2Saga from './dailySessionNotes/getPatientInfoV2Saga';
import getPrintStatusSaga from './dailySessionNotes/getPrintStatusSaga';
import deleteDailySessionNoteSaga from './dailySessionNotes/deleteDailySessionNoteSaga';
import archiveDailySessionNoteSaga from './dailySessionNotes/archiveDailySessionNoteSaga';
import getArchivedDocumentsSaga from './dailySessionNotes/getArchivedDocumentsSaga';
import editTaskTimeSaga from './therapistSaga/editTaskTimeSaga';
import taskAvailabilitySaga from './therapistSaga/taskAvailabilitySaga';
import splitTaskMinSaga from './therapistSaga/split-task/splitTaskMinSaga';
import editSplitTaskMinSaga from './therapistSaga/split-task/editSplitTaskMinSaga';
import getSplitTaskSaga from './therapistSaga/split-task/getSplitTaskSaga';
import deleteSplitTaskMinSaga from './therapistSaga/split-task/deleteSplitTaskSaga';
import checkSplitMinPlannerSaga from './therapistSaga/split-task/check-split-min-planner';
import getSupervisorAlertSaga from './departmentDashboard/getSupervisorAlertSaga';
import getPhysicianSignaturePendingSaga from './departmentDashboard/getPhysicianSignaturePendingSaga';
import getAllPhysiciansSaga from './departmentDashboard/getAllPhysiciansSaga';
import getPendingSignaturePhysiciansSaga from './departmentDashboard/getPendingSignaturePhysiciansSaga';
import getSupervisorAlertSettingSaga from './departmentDashboard/getSupervioryAlertSetting';
import getTherapistInfoSaga from './documentation/getTherapistInfoSaga';
import addSignOnBehalfSaga from './documentation/addSignOnBehalfSaga';
import getDsnSummarySaga from './therapist-dashboard-saga/get-dsn-summary-saga';

import createPatientPayerSaga from './patient-payer/createPatientPayerSaga';
import getAllPatientPayersSaga from './patient-payer/getAllPatientPayerSaga';
import getPayerOptionsSaga from './patient-payer/getPayerOptionsSaga';
import getPayerDateRangesSaga from './patient-payer/getPayerDateRangesSaga';
import getPayerHistorySaga from './patient-payer/getPayerHistorySaga';
import updatePatientPayerSaga from './patient-payer/updatePatientPayerSaga';
import validateMdsPayerSaga from './patient-payer/validateMdsPayerSaga';
import getPbjExportSaga from './pbj/getPbjExportSaga';
import getAllPatientPriorChargesSaga from './patient/getAllPatientPriorChargesSaga';
import reopenCloseoutSaga from './monthlyCloseOutAlret/reopenCloseoutSaga';
import {
  createCustomCloseoutSaga,
  updateCustomCloseoutSaga,
  cancelCustomCloseoutSaga,
} from './monthlyCloseOutAlret/customCloseoutSaga';
import getPayerFiltersSaga from './documentBundle/getPayerFiltersSaga';
import getPatientFiltersSaga from './documentBundle/getPatientFiltersSaga';
import getDocumentSummarySaga from './documentBundle/getDocumentSummarySaga';
import getDownloadJobsSaga from './documentBundle/getDownloadJobsSaga';
import submitDownloadJobSaga from './documentBundle/submitDownloadJobSaga';
import getPresignedUrlSaga from './documentBundle/getPresignedUrlSaga';
import getTherapistFiltersSaga from './documentBundle/getTherapistFiltersSaga';
import searchPatientsSaga from './documentBundle/searchPatientsSaga';
import getPatientIntervalsSaga from './documentBundle/getPatientIntervalsSaga';
import getPatientDocumentsSaga from './documentBundle/getPatientDocumentsSaga';

function* rootSaga() {
  yield all([
    call(updateTherapyPlanningDischargeDateSaga),
    call(getSingleTherapistDisciplineSaga),
    call(checkTherapyPlanningPlanMinutesSaga),
    call(getDataOfServiceSaga),
    call(getIsTherapyPlanningPatient),
    call(defaultTherapistAssignSaga),
    call(autoMatchingTherapistSaga),
    call(disableAutoMatchSaga),
    call(updateTreatmentTherapistSaga),
    call(getAllTherapistDisciplineSaga),
    call(deletePatientTaskSaga),
    call(dashboardDocumentationOverviewSaga),
    call(dashboardTherapySessionOverviewSaga),
    call(getLaborCodes),
    call(getAllDisciplineTherapistsSaga),
    call(getSkillListSchedulingSaga),
    call(updateDailySessionNotesSaga),
    call(createAssessment),
    call(getFiveDayArdWindowSaga),
    call(getCaseMixGroupSaga),
    call(getCmgResolutionSaga),
    call(getCmgStatusSaga),
    call(getPdpmFeatureToggleSaga),
    call(getDepartmentPTOSaga),
    call(getDepartmentTherapyMinsSaga),
    call(updateDepartmentPTORequestSaga),
    call(getDepartmentDashboardCountSaga),
    call(getDailySessionNotesSaga),
    call(getDailySessionPatientListSaga),
    call(getPatientInfoSaga),
    call(getTherapyPlanning),
    call(updateTherapyPlanning),
    call(getAssessment),
    call(closeEpisodeOfCareSaga),
    call(getMDSAssessment),
    call(getPlanOfCare),
    call(updateAssessment),
    call(therapistLoginSaga),
    call(getTherapyPlanningPatientSaga),
    call(createPatientSaga),
    call(editPatientSaga),
    call(therapistLogoutSaga),
    call(createEpisodeOfCareSaga),
    call(editEpisodeOfCareSaga),
    call(getSingleEpisodeOfCareSaga),
    call(getEpisodeOfCareSaga),
    call(getScreeningSaga),
    call(createScreeningSaga),
    call(setPasswordSaga),
    call(getTherapistProfileSaga),
    call(getSinglePatientSaga),
    call(getFacilityDropDownSaga),
    call(updateSoapNoteSaga),
    call(updateFacilityDropDownSaga),
    call(getPatientRecordSaga),
    call(getAllFacilitiesStaySaga),
    call(updateFacilitiesStaySaga),
    call(getDisciplineTypeSaga),
    call(getScreeningTypeSaga),
    call(getSingleScreeningSaga),
    call(deactivatePatientsSaga),
    call(getAllPhysicianSaga),
    call(createFacilitiesStaySaga),
    call(autoGeneratePasswordSaga),
    call(PostResetPasswordSaga),
    call(getMyAvailabilitySaga),
    call(getAllPtoRequestSaga),
    call(createPtoRequestSaga),
    call(removePtoRequestSaga),
    call(getOtherPatientInfoSaga),
    call(editMyAvailabilitySaga),
    call(getAllTherapistTaskSaga),
    call(getAllTaskTypeSaga),
    call(getAllTherapistListSaga),
    call(getAppointmentSlotsSaga),
    call(scheduleAppointmentSaga),
    call(scheduleRecurringAppointmentSaga),
    call(updateRecurringSeriesSaga),
    call(cancelRecurringSeriesSaga),
    call(getPatientTimeSlotsSaga),
    call(getRecurringAppointmentCountSaga),
    call(getAllTherapistDiciplineListSaga),
    call(therapistAssignTaskSaga),
    call(therapistMigrateTaskSagaSaga),
    call(therapistMigratePatientSaga),
    call(therapistAddTaskSaga),
    call(therapistSchedulingTaskEditSaga),
    call(getPayerPlanTypeSaga),
    call(therapistAssignmentUndoSaga),
    call(getAllFacilitiesSaga),
    call(getAllTemplatesSaga),
    call(rearrangeTherapistTaskSaga),
    call(therapistDialogAssignTaskSaga),
    call(editTaskTimeSaga),
    call(taskAvailabilitySaga),
    call(assignSignerSaga),
    call(getAllSubmittedDocumetSaga),
    call(getSubmissionDocumentSaga),
    call(getAllTherapistsByDiscipline),
    call(getAllMiscellaneousDocumentsSaga),
    call(saveMiscellaneousDocumentSaga),
    call(dashboardPatientListSaga),
    call(todayPatientListSaga),
    call(dashboardDocumentListSaga),
    call(dashboardTaskOverviewSaga),
    call(dashboardTimeCheckInSaga),
    call(dashboardTimeCheckOutSaga),
    call(getAllSupervisiorsSaga),
    call(dashboardPatientInfoSaga),
    call(getEpisodeOfCareRequiredDocumentSaga),
    call(getNoteTemplateSaga),
    call(submitEsignSaga),
    call(getFormIdForScreeningSaga),
    call(saveScreeningSubmissionSaga),
    call(getPatientInOrActiveCountsSaga),
    call(sendMailToPhysicianSaga),
    call(getMonthEndAlertCountSaga),
    call(getMonthEndAlertThemeCountSaga),
    call(getOwnerAlertCountSaga),
    call(getListofMonthEndAlertSaga),
    call(getAllCodesSaga),
    call(dashboardPtoUpdatedSaga),
    call(getCPTCodeByDisciplineSaga),
    call(editAuthorizationSaga),
    call(getDownloadCsvTemplateSaga),
    call(validateCSVTemplateSaga),
    call(uploadCsvTemplateSaga),
    call(getRecentUploadedHistorySaga),
    call(getPatientExportCsvSaga),
    call(getTherapistAvailabilitySaga),
    call(certifyMonthEndAlertSaga),
    call(getCertificationStatusSaga),
    call(dashboardInterventionGroupSaga),
    call(dashboardGameByInterventionGroupSaga),
    call(getSignatureAccessSaga),
    call(getTargetSignatureAccessSaga),
    call(getAllPatientSaga),
    call(getAuthorizationDetailsSaga),
    call(getAllICDCodesSaga),
    call(pullUuidSaga),
    call(PreGetFacilityDropDownSaga),
    call(preGetTherapistProfileSaga),
    call(getPayComeDetailsSaga),
    call(clockInOutButtonVisibilitySaga),
    call(reAssignTherapistSaga),
    call(getAlTherapistListSaga),
    call(getLaborHoursSaga),
    call(addLaborHoursSaga),
    call(editLaborHoursSaga),
    call(getLocationTypeLaborHrSaga),
    call(checkSignatureDailyNotesSaga),
    call(deleteLaborHoursSaga),
    call(getNpcEntriesSaga),
    call(getNpcActivityTypesSaga),
    call(addNpcEntrySaga),
    call(editNpcEntrySaga),
    call(deleteNpcEntrySaga),
    call(getNpcTeamEntriesSaga),
    call(getNpcTeamEntriesEditableSaga),
    call(reviewNpcEntrySaga),
    call(getLaborReportSaga),
    call(getBuildingsOverviewSaga),
    call(getLaborEntryHistorySaga),
    call(updateLaborEntryStatusSaga),
    call(getLaborValidationToggleSaga),
    call(getPayPeriodCyclesSaga),
    call(approvePayPeriodSaga),
    call(getPayPeriodByDateSaga),
    call(getContractCountSaga),
    call(monthlyCloseoutAlertSaga),
    call(getUnlockTherapistSaga),
    call(getLockDailySessionNoteSaga),
    call(updateUnlockTherapistSaga),
    call(uploadSignatureFileSaga),
    call(getMultipleMdsAssessmentSaga),
    call(deleteRequiredDocSaga),
    call(getPrepareProgressNoteSaga),
    call(getAutoClockOutSaga),
    call(getPaginatedPatientSaga),
    call(dashboardDocumentListCsvSaga),
    call(getCPTCodesDescriptionSaga),
    call(validateMdsAssessmentSaga),
    call(uploadMdsCsvTemplateSaga),
    call(getPatientListRecordSaga),
    call(getAllCompetedDocSaga),
    call(getPhysicianDocumentsSaga),
    call(updateDocumentStatusesSaga),
    call(getFacilitySaga),
    call(getAllPatientByEnterpriseSaga),
    call(checkAssignTaskPTOSaga),
    call(getPhysicianCompletedDocumentsSaga),
    call(getTherapyPlanningPatientSaga_2_0),
    call(getTherapyPlanningDataSaga_2_0),
    call(getTherapyPlanningSummarySaga_2_0),
    call(editSingleCellTherapyPlanningSaga),
    call(updateAppointmentEndTimeSaga),
    call(updateUncoveredDayTherapyPlanningSaga),
    call(getTherapyPlanningDischargeDateSaga_2_0),
    call(copyPasteTherapyPlanningSaga_2_0),
    call(getAllSubmittedDocumentForResolver),
    call(applyTheTherapyTemplatesSaga),
    call(getAllTherapyPlanningTemplatesSaga),
    call(applySelectedTherapyTemplateSaga),
    call(createNewTherapyTemplateSaga),
    call(deleteTherapyTemplateSaga),
    call(editTherapyTemplateSaga),
    call(getSchedulingTaskNoteSaga),
    call(createSchedularTaskNoteSaga),
    call(deleteTaskNoteSchedularSaga),
    call(therapistPatientUnAssign),
    call(getMdsAssessmentRangeSaga),
    call(getPayerDayCountSaga),
    call(getSingleMdsAssessmentSaga),
    call(deleteMdsAssessmentByDateSaga),
    call(deleteSingleMdsAssessmentSaga),
    call(maintainTherapistFilterSaga),
    call(getAllMaintainedTherapistSaga),
    call(getSchedularAnnouncementsSaga),
    call(createAnnouncementSaga),
    call(updateAnnouncementSaga),
    call(deleteAnnouncementSaga),
    call(getTherapyPlanning7dayLookBackSaga),
    call(therapistDailyUpdatesSaga),
    call(dashboardSupervisorEditSaga),
    call(isDischargeDocumentAllowSaga),
    call(recheckDischargeOverrideStatusSaga),
    call(approveRecheckDischargeSaga),
    call(newDocumentSignSaga),
    call(undoDocumentSignSaga),
    call(holdDailyNoteFromBillingSaga),
    call(checkPendingDocsAlertSaga),
    call(setCommonDurationSaga),
    call(updateTimeBasisSaga),
    call(dueDocSettingsSaga),
    call(otherDashboardDocumentListSaga),
    call(myDashboardDocumentListSaga),
    call(coSignatureReviewSaga),
    call(therapistBulkSignatureSaga),
    call(signingPinSaga),
    call(getPatientInfoV2Saga),
    call(getPrintStatusSaga),
    call(deleteDailySessionNoteSaga),
    call(archiveDailySessionNoteSaga),
    call(getArchivedDocumentsSaga),
    call(splitTaskMinSaga),
    call(editSplitTaskMinSaga),
    call(getSplitTaskSaga),
    call(deleteSplitTaskMinSaga),
    call(checkSplitMinPlannerSaga),
    call(getSupervisorAlertSaga),
    call(getSupervisorAlertSettingSaga),
    call(getPhysicianSignaturePendingSaga),
    call(getTherapistInfoSaga),
    call(addSignOnBehalfSaga),
    call(getDsnSummarySaga),
    call(createPatientPayerSaga),
    call(getAllPatientPayersSaga),
    call(getPayerOptionsSaga),
    call(getPayerDateRangesSaga),
    call(getPayerHistorySaga),
    call(updatePatientPayerSaga),
    call(getAllPatientPriorChargesSaga),
    call(getAllPhysiciansSaga),
    call(getPendingSignaturePhysiciansSaga),
    call(reopenCloseoutSaga),
    call(createCustomCloseoutSaga),
    call(updateCustomCloseoutSaga),
    call(cancelCustomCloseoutSaga),
    call(getPayerFiltersSaga),
    call(getPatientFiltersSaga),
    call(getTherapistFiltersSaga),
    call(searchPatientsSaga),
    call(getPatientIntervalsSaga),
    call(getPatientDocumentsSaga),
    call(getDocumentSummarySaga),
    call(getDownloadJobsSaga),
    call(submitDownloadJobSaga),
    call(getPresignedUrlSaga),
    call(verifyMdsPpsSaga),
    call(validateMdsPayerSaga),
    call(getPbjExportSaga),
  ]);
}

export default rootSaga;
